import React from 'react';
import { Nav } from 'react-bootstrap';
import '../style/sidebar.css'; // Estilos customizados
import menuLogo from "../assets/imagens/pentalobe.png";
import {useLocation } from 'react-router-dom'; // Importe Link e useLocation para roteamento
const SidebarUser = ({ isOpen }) => {
  const location = useLocation(); // Hook para acessar a localização atual
  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
      {/* Logo */}
      <div className="sidebar-header d-none d-lg-block">
        <img className="fundo-imagem-dasboard" src={menuLogo} alt="fundo-imagem-dasboard" />
      </div>

      {/* Menu de navegação */}
      <Nav defaultActiveKey="/dashboard" className="flex-column">
        <Nav.Link href="/dashboard"  active={location.pathname === '/dashboard'} className="d-flex align-items-center">
          <i className="fas fa-home me-2"></i>
          <span className="d-none d-lg-block">Home</span>
        </Nav.Link>
        <Nav.Link href="/propostas-user" active={location.pathname === '/propostas-user'} className="d-flex align-items-center">
          <i className="fa-solid fa-business-time me-2"></i>
          <span className="d-none d-lg-block">Pedido de Compras</span>
        </Nav.Link>
        <Nav.Link href="/pedidos" active={location.pathname === '/pedidos'} className="d-flex align-items-center">
          <i className="fa-solid fa-cart-shopping me-2"></i>
          <span className="d-none d-lg-block">Pedido de Vendas</span>
        </Nav.Link>
        <Nav.Link href="/editar-usuario" active={location.pathname === '/editar-usuario'} className="d-flex align-items-center">
          <i className="fa-solid fa-user-tie me-2"></i>
          <span className="d-none d-lg-block">Cadastro</span>
        </Nav.Link>
      </Nav>
    </div>
  );
};

export default SidebarUser;
